import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickBigCorrect({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 174 88"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#E9F7EE" cx={87} cy={44} r={44} />
        <path
          d="M23.961 21.264c-8.615 15.076-8.615 30.396 0 45.472a3.5 3.5 0 006.078-3.472c-7.385-12.924-7.385-25.604 0-38.528a3.5 3.5 0 00-6.078-3.472z"
          fill="#E9F7EE"
          opacity={0.48}
        />
        <path
          d="M2.212 31.8C-.737 39.88-.737 48.06 2.21 56.192a3.5 3.5 0 106.582-2.384C6.404 47.219 6.404 40.733 8.788 34.2a3.5 3.5 0 00-6.576-2.4z"
          fill="#E9F7EE"
          opacity={0.4}
        />
        <path
          d="M150.04 21.264c8.614 15.076 8.614 30.396 0 45.472a3.5 3.5 0 11-6.078-3.472c7.385-12.924 7.385-25.604 0-38.528a3.5 3.5 0 016.077-3.472z"
          fill="#E9F7EE"
          opacity={0.48}
        />
        <path
          d="M171.789 31.8c2.949 8.08 2.949 16.26.003 24.392a3.5 3.5 0 11-6.582-2.384c2.387-6.589 2.387-13.075.003-19.608a3.5 3.5 0 116.576-2.4z"
          fill="#E9F7EE"
          opacity={0.4}
        />
        <path
          stroke="#3EA769"
          strokeWidth={9.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M70 43.42l11.79 11.79L104 33"
        />
      </g>
    </svg>
  );
}

SvgTickBigCorrect.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickBigCorrect.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickBigCorrect svgRef={ref} {...props} />);
export default ForwardRef;
